import type { CandleWithFlag } from "features/chart";

export interface SuperTrendResult {
  values: (number | null)[];
  isUptrend: boolean[];
}

export function calcSuperTrend(
  data: CandleWithFlag[],
  atrPeriod: number,
  multiplier: number,
): SuperTrendResult {
  const n = data.length;
  const values: (number | null)[] = new Array(n).fill(null);
  const isUptrend: boolean[] = new Array(n).fill(true);
  if (n < atrPeriod + 1) return { values, isUptrend };

  // Wilder's ATR
  const atr: number[] = new Array(n).fill(0);
  let sumTR = 0;
  for (let i = 1; i <= atrPeriod; i++) {
    const tr = Math.max(data[i].high - data[i].low, Math.abs(data[i].high - data[i - 1].close), Math.abs(data[i].low - data[i - 1].close));
    sumTR += tr;
  }
  atr[atrPeriod] = sumTR / atrPeriod;
  for (let i = atrPeriod + 1; i < n; i++) {
    const tr = Math.max(data[i].high - data[i].low, Math.abs(data[i].high - data[i - 1].close), Math.abs(data[i].low - data[i - 1].close));
    atr[i] = (atr[i - 1] * (atrPeriod - 1) + tr) / atrPeriod;
  }

  let upperBand = 0, lowerBand = 0, prevUpper = 0, prevLower = 0;
  let prevUptrend = true;

  for (let i = atrPeriod; i < n; i++) {
    const hl2 = (data[i].high + data[i].low) / 2;
    const basicUpper = hl2 + multiplier * atr[i];
    const basicLower = hl2 - multiplier * atr[i];

    upperBand = (basicUpper < prevUpper || data[i - 1].close > prevUpper) ? basicUpper : prevUpper;
    lowerBand = (basicLower > prevLower || data[i - 1].close < prevLower) ? basicLower : prevLower;

    const uptrend: boolean = prevUptrend
      ? data[i].close >= lowerBand
      : data[i].close > upperBand;

    values[i] = uptrend ? lowerBand : upperBand;
    isUptrend[i] = uptrend;

    prevUpper = upperBand;
    prevLower = lowerBand;
    prevUptrend = uptrend;
  }

  return { values, isUptrend };
}
